import React from 'react'
import classNames from 'classnames'
import { CrossClientProgress } from './CrossClientProgress'
import './CrossClientQueuedProgress.scss'

export interface CrossClientQueuedProgressProps {
  className?: string
  iconClassName?: string
}

export const CrossClientQueuedProgress: React.FC<CrossClientQueuedProgressProps> = ({ className, iconClassName }) => (
  <div className='cross-client-queued-stack'>
    <CrossClientProgress className={className} total={1} done={0} />
    <i className={classNames('cross-client-queued-icon bi bi-hourglass-split zocks-text-primary', iconClassName)} />
  </div>
)
